import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    narrateScreen, selectPracticeScreenResponse, handleOnNext,
} from './RCTAccuracyPracticeActions';
import { ACCURACY_PRACTICE_POST_AUDIO_CALLBACK } from './RCTAccuracyPracticeAvatarActions';
import MultiChoiceQuestionView from '../../../../common/questions/multiChoiceQuestionView';
import * as multiChoiceUtils from '../../../../common/questions/multiChoiceQuestionUtils';
import { RCT, ACCURACY } from '../../../../constants/measure';
import { PRACTICE } from '../../../../constants/assessmentItemType';
import selectors from '../../../../rootSelectors';
import { fetchRctAccuracyContent } from '../../../rctActions';
import RCT_AUDIO_INSTRUCTIONS from '../../../rctConstants';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';

const ACCURACY_AUDIO = RCT_AUDIO_INSTRUCTIONS.ACCURACY;

const mapStateToProps = (state) => {
    const props = multiChoiceUtils.mapStateToProps(state);
    return {
        ...props,
        pageLayout: `${RCT}-${ACCURACY} ${PRACTICE}`,
        isDataFetched: selectors.getIsRCTAccuracyDataFetched(state),
        possibleResponses: selectors.getRCTAccuracyPossibleResponses(state, PRACTICE),
        stimulusAudio: selectors.getRCTAccuracyStimulusAudio(state, PRACTICE),
    };
};

const mapDispatchToProps = (dispatch) => {
    const props = multiChoiceUtils.mapDispatchToProps(dispatch);
    return {
        ...props,
        onNext: () => {
            dispatch(handleOnNext());
        },
        narrateScreen: (stimulusAudio) => {
            dispatch(narrateScreen(stimulusAudio));
        },
        selectResponse: (index) => {
            dispatch(selectPracticeScreenResponse(index));
        },
        fetchContent: () => {
            dispatch(fetchRctAccuracyContent());
        },
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.MIDDLE_LEFT,
    instructions: ACCURACY_AUDIO.avatarStart,
    postAudioCallback: ACCURACY_PRACTICE_POST_AUDIO_CALLBACK,
});

const RCTAccuracyPracticeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MultiChoiceQuestionView);

export default RCTAccuracyPracticeContainer;
